"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBike = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M18 5.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z' }),
    react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M10 16a4 4 0 11-8 0 4 4 0 018 0zm-2 0a2 2 0 11-4 0 2 2 0 014 0zM22 16a4 4 0 11-8 0 4 4 0 018 0zm-2 0a2 2 0 11-4 0 2 2 0 014 0z' }),
    react_1.default.createElement("path", { d: 'M12.657 12.243a.86.86 0 01.026.027A.997.997 0 0113 13v4a1 1 0 11-2 0v-3.586l-2.585-2.585a1.01 1.01 0 01-.096-.111 1.5 1.5 0 01.386-2.28l3.813-2.201a1.5 1.5 0 011.828.255.997.997 0 01.187.235L15.846 9h2.434a1 1 0 110 2h-3a.996.996 0 01-.51-.14.995.995 0 01-.373-.37l-.812-1.406-2.59 1.496 1.662 1.663z' }))); };
exports.default = SvgBike;
//# sourceMappingURL=Bike.js.map